import { toast, ToastOptions } from 'react-toastify';
import i18n from 'i18n/i18n';

export enum ToastMessageReason {
  ERROR = 1,
  VALID,
  PENDING,
}

(window as any).toast = toast;

export class Toast {
  public static openToastSuccessMessage(
    message: string,
    options?: ToastOptions
  ) {
    toast.success(message, options);
  }
  public static openToastPendingMessage(
    message: string,
    options?: ToastOptions
  ) {
    toast.info(message, options);
  }
  public static openToastErrorMessage(message: string, options?: ToastOptions) {
    toast.error(message, options);
  }

  public static openGenericErrorToast(options?: ToastOptions) {
    toast.error(i18n.t('SSCandidate_Errors_Generic', { ns: 'Errors' }), options);
  }
}
